export default __webpack_public_path__ + "static/media/biomedicModuleImage.047554d1.svg";